<template lang="pug">
  main
    NavBar
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column
            b.has-text-black(@click="backPage")
              a.button.is-light.is-rounded
                span.icon
                  i.fas.fa-angle-left
                | &nbspRegresar
        .columns
          .column.is-1
            label.label Fecha
          .column.is-2
            .field
              .control
                flat-pickr(
                  v-model='fechaJornada'
                  :config="config"
                  class="input"
                )
          .column
            a.button.is-black.is-rounded.is-small(@click="iniciarComponente")
              span.icon
                i.fas.fa-sync
            | &nbsp
            a.button.is-success.is-rounded.is-small(@click="descargarReporte('normal')")
              b
                | Rep. Báscula&nbsp
              span.icon
                i.fas.fa-file-excel
            | &nbsp
            a.button.is-success.is-rounded.is-small(v-show="verPesoNeto" @click="descargarReporte('mov')")
              b
                | Rep. Movenergy&nbsp
              span.icon
                i.fas.fa-file-excel
            | &nbsp
            a.button.is-success.is-rounded.is-small(@click="descargarReporte('pemex')")
              b
                | Rep. Pemex&nbsp
              span.icon
                i.fas.fa-file-excel
            | &nbsp
            a.button.is-success.is-rounded.is-small(v-show="verSellosCortosLargos" @click="descargarReporteSellos")
              b
                | Rep. Sellos&nbsp
              span.icon
                i.fas.fa-file-excel
          .column.is-offset-1.is-1
            label.label Filtrar
          .column.is-3
            .field
              .control
                input.input.is-primary(
                  type='text', 
                  placeholder='Filtrar por PG | Sello',
                  v-model="query",
                )
        .columns
          .column.is-offset-9.is-2
            .field
              .control
                input.input.is-primary(
                  type='text', 
                  placeholder='Buscar historial PG',
                  v-model="searchPg",
                )
          a.button.is-rounded.is-small(@click="realizarBusqueda")
            span.icon
              i.fas.fa-search
            | &nbsp Buscar
        br
        .columns
          .column.is-12
            div.control
              label.radio.label-radio.is-primary
                input#iALL.is-primary(type='radio', value='ALL' v-model='filter' checked='checked')
                | TODOS
              label.radio.label-radio.is-primary(v-for="porc in porcentajes") 
                input.is-radio-input.is-primary(type='radio' :value='porc.unidadNeg' v-model='filter' :id="porc.unidadNeg")
                | {{ porc.negocio}}
        .columns.has-text-centered
          .column.is-12
              ContainerAutotanques(:verPesoNeto="verPesoNeto" :autotanques="autotanquesShow" :nominaciones="nominaciones" :sca_sellosCL="verSellosCortosLargos" @eventLoading="eventLoading" @updateAutanques="updateAutanques")
        .columns(v-show="autotanquesShow.length == 0")
          .column.is-12
            .notification
              |   No hay registros con éstos criterios de Búsqueda.   
        .columns.column-blanco
</template>

<script>
  import Loader from '@/components/shared/Loader.vue'
  import NavBar from './layout/NavBar.vue'
  import flatPickr from 'vue-flatpickr-component'
  import 'flatpickr/dist/flatpickr.css'
  import { Spanish } from "flatpickr/dist/l10n/es.js"
  import moment from 'moment'
  import nominaciones_tpaServices from '@/services/sca/nominaciones/nominacionesTpa.js'
  import accesos_tpaServices from '@/services/sca/accesos/accesosTPA.js'
  import sca_tuxpanServices from '@/services/sca/tpa.js'
  import ContainerAutotanques from './componentes/ContainerAutotanques.vue'

  export default {
    name: 'Bascula',
    components: { Loader, NavBar, flatPickr, ContainerAutotanques },
    data() {
      return {
        isLoading: true,
        fechaJornada: moment().format('YYYY-MM-DD'),
        config: {
          wrap: true, // set wrap to true only when using 'input-group'
          altFormat: 'Y-m-d',
          altInput: true,
          dateFormat: 'Y-m-d',
          locale: Spanish, // locale for this instance only          
        },
        autotanques: [],
        autotanquesShow: [],
        filter: 'ALL',
        query: '',
        nominaciones: [],
        configuracion: {},
        aTCargados: [],
        porcentajes: [],
        verPesoNeto: false,
        verSellosCortosLargos: false,
        searchPg:'',
        palabra:'',
      }
    },
    watch: {
      fechaJornada() {
        this.iniciarComponente()
      },
      filter () {
        if (this.filter === 'ALL') {
          this.autotanquesShow = this.autotanques
        } else {
          this.autotanquesShow = this.autotanques.filter( at => at.subgrupo === this.filter)
        }
      },
      
      query () {
        const QUERY = this.query.toUpperCase()
        const accesosFilter = this.autotanques.filter( acc => {
          const sellosArray = []
          acc.sellos.map( sell => sellosArray.push(sell.sello))
          let sellosText = ''
          for (let index = 0; index < sellosArray.length; index++) {
            sellosText += `${sellosArray[index]} ` 
          }
          return `${acc.pg} ${sellosText}`.toUpperCase().includes(QUERY)
        })
        this.autotanquesShow = accesosFilter
      }
    },
    methods: {
      iniciarComponente () {
        this.isLoading = true
        this.obtenerConfiguracion()
      },

      obtenerConfiguracion () {
        this.configuracion = {}
        sca_tuxpanServices.obtenerConfiguracion()
          .then( data => {
            this.configuracion = this.convertirConfiguracion(data[0])
            this.verPesoNeto = this.configuracion.sca_pesoNeto
            this.verSellosCortosLargos = this.configuracion.sca_sellosCL
            this.obtenerNominacionFecha()
          })
          .catch(e => {
            this.isLoading = false
            this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'OK')
          })       
      },

      convertirConfiguracion(config) {
        return {
          ...config,
          sca_pesoNeto: config.sca_pesoNeto === '1' ? true : false,
          sca_pemexReportes: config.sca_pemexReportes === '1' ? true : false,
          sca_cargasSCA_Pemex: config.sca_cargasSCA_Pemex === '1' ? true : false,
          sca_sellosCL: config.sca_sellosCL === '1' ? true : false,
        }
      },

      obtenerNominacionFecha () {
        this.nominaciones = []
        nominaciones_tpaServices.obtenerNominacionFecha(this.fechaJornada)
          .then( data => {
            this.nominaciones = data.map(this.convetirNominaciones)
            setTimeout(() => {
              this.obtenerCargas()
            }, 2000)
          })
          .catch(e => {
            this.isLoading = false
            this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'OK')
          })
      },

      obtenerAutotanques() {
        this.autotanques = []
        accesos_tpaServices.getAccesos(this.fechaJornada)
          .then( data => {
            this.autotanques = data.map(this.convetirAutotanques)
            this.autotanquesShow = this.autotanques
            this.isLoading = false
          })
          .catch(e => {
            this.isLoading = false
            this.displayToast('bubble', `Error: ${e.message}`, 'ban', 'OK')
          })
      },

      convetirAutotanques (auto) {
        const visita = Number(auto.visita)
        const pgCargado = this.aTCargados.find( aTC => aTC.pg === auto.pg && aTC.visita == visita)
        let masaLlenadera = 0
        if (pgCargado) {
          masaLlenadera = pgCargado.masaKgs
        } else {
          masaLlenadera = 0
        }
        return {
          ...auto,
          id: parseInt(auto.id),
          embarque: parseInt(auto.embarque),
          estado: parseInt(auto.estado),
          programa: parseInt(auto.programa),
          presion: Number(auto.presion),
          magnatel: Number(auto.magnatel),
          pesoEntrada: Number(auto.pesoEntrada),
          pesoSalida: Number(auto.pesoSalida),
          visita,
          masaLlenadera,
        }
      },

      convetirNominaciones(nom) {
        return {
          ...nom,
          id: parseInt(nom.id),
          nominacion: parseInt(nom.nominacion)
        }
      },

      eventLoading (val) {
        this.isLoading = val
      }, 

      updateAutanques (val) {
        if (val) {
          this.iniciarComponente()
        }
      },

      descargarReporte (cliente) {
        this.isLoading = true
        sca_tuxpanServices.createExcel_bascula(this.fechaJornada, cliente)
          .then( data => {
            if (data.success) {
              const currentUrl = window.location.hostname
              const link = `https://${currentUrl}/reportesApp/server/excel/generarRBascula_TPA.php?nameFile=${data.file}`
              open(link, '_blank')
              setTimeout(() => {
                sca_tuxpanServices.borrarArchivo(data.file)
                  .then( dataD => {
                    this.displayToast(dataD.excelBorrado ? 'toasted-primary' : 'bubble', dataD.excelBorrado ? 'Archivo descargado' : 'El archivo no se pudo borrar', dataD.excelBorrado ? 'check' : 'ban', 'OK')
                    this.isLoading = false
                  })
                  .catch(err => {
                    this.displayToast('bubble', `Error2: ${err.message}`, 'ban', 'OK')
                    this.isLoading = false
                  })
              }, 4000)
            } else {
              this.displayToast('bubble', `Error::: ${data.excelBorrado}`, 'ban', 'OK')
            }
          })
          .catch( e => {
            this.displayToast('bubble',`Error1: ${e.message}`, 'ban', 'OK')
            this.isLoading = false
          })
      },

      displayToast(tema, text, icon, actionText) {
        let toast = this.$toasted.show(text, { 
          theme: tema, 
          position: "bottom-right", 
          duration : 1000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },

      backPage() {
        this.$router.back()
      },

      obtenerCargas () {
        this.aTCargados = []
        sca_tuxpanServices.getCargas(this.fechaJornada)
          .then( data => {
            this.aTCargados = data.map(this.convetirCargas)
            this.calcularPorcentajes()          
          })
          .catch(e => {
            this.isLoading = false
            this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'OK')
          })
      },

      convetirCargas (carga) {
        const pgCargado = this.autotanques.some( pg => pg.pg === carga.pg)
        let subgrupo = ''
        if (pgCargado) {
          const pgsAcc = this.autotanques.filter( pg => pg.pg === carga.pg)
          const existeVisita =  pgsAcc.some( pg => pg.visita == carga.visita)
          if (existeVisita) {
            const pgFinded = pgsAcc.find( pg => pg.visita == carga.visita)
            subgrupo = pgFinded.subgrupo
          }
        }
        return {
          ...carga,
          id: parseInt(carga.id),
          capacidad90: Number(carga.capacidad90),
          capturado: parseInt(carga.capturado),
          contenido: Number(carga.contenido),
          densidad: Number(carga.densidad),
          densidad20: Number(carga.densidad20),
          folioCarga: Number(carga.folioCarga),
          masa: Number(carga.masa),
          masaKgs: Number(carga.masaKgs),
          masaPura: Number(carga.masaPura),
          porcentaje: Number(carga.porcentaje),
          presion: Number(carga.presion),
          temperatura: Number(carga.temperatura),
          volumen: Number(carga.volumen),
          volumen20: Number(carga.volumen20),
          subgrupo: subgrupo,
          visita: parseInt(carga.visita)
        }
      },

      calcularPorcentajes() {
        this.porcentajes = []
        this.porcentajes = this.nominaciones.map(this.convetirPorcentajes)
        this.obtenerAutotanques()
      },

      convetirPorcentajes (nom) {
        const tanquesNom = this.aTCargados.filter( pg => pg.subgrupo === nom.unidadNeg)
        const masaSurtida = (tanquesNom.reduce( (acc, { masa } ) => acc + masa, 0)).toFixed(3)
        const porcentajeSurtido = ((masaSurtida * 100) / nom.nominacion).toFixed(2)
        const restante = (nom.nominacion - masaSurtida).toFixed(3)
        return {
          ...nom,
          surtido: Number(masaSurtida),
          porcentaje: Number(porcentajeSurtido),
          restante: Number(restante),
          negocio: nom.subgrupo,
          orden: parseInt(nom.orden)
        }
      },

      descargarReporteSellos () {
        const currentUrl = window.location.hostname
        const link = `https://${currentUrl}/reportesApp/server/excel/Reporte_sellosTPA.php?fecha=${this.fechaJornada}`
        open(link, '_blank')
      },

      async realizarBusqueda (){
        this.palabra = this.searchPg
        this.obtenerCargasBusqueda(this.palabra)
      },

      obtenerCargasBusqueda(palabra) {
        this.aTCargados = []
        sca_tuxpanServices.getCargasBusqueda(palabra)
          .then( data => {
            this.aTCargados = data.map(this.convertirCargasBusqueda)
            this.obtenerAccesoBusqueda(palabra)
          })
          .catch(e => {
            this.isLoading = false
            this.displayToast('bubble',`Error: ${e.message}`, 'ban', 'OK')
          })
      },

      obtenerAccesoBusqueda(palabra) {
        this.autotanques = []
        accesos_tpaServices.getAccesosByPg(palabra)
          .then( data => {
            this.autotanques = data.map(this.convertirAutotanquesEmbarque)
            this.autotanquesShow = this.autotanques
            this.isLoading = false
          })
          .catch(e => {
            this.isLoading = false
            this.displayToast('bubble', `Error: ${e.message}`, 'ban', 'OK')
          })
      },

      convertirCargasBusqueda (carga) {
        return {
          ...carga,
          id: parseInt(carga.id),
          capacidad90: Number(carga.capacidad90),
          capturado: parseInt(carga.capturado),
          contenido: Number(carga.contenido),
          densidad: Number(carga.densidad),
          densidad20: Number(carga.densidad20),
          folioCarga: Number(carga.folioCarga),
          masa: Number(carga.masa),
          masaKgs: Number(carga.masaKgs),
          masaPura: Number(carga.masaPura),
          porcentaje: Number(carga.porcentaje),
          presion: Number(carga.presion),
          temperatura: Number(carga.temperatura),
          volumen: Number(carga.volumen),
          volumen20: Number(carga.volumen20),
          subgrupo: carga.subgrupo,
          visita: parseInt(carga.visita)
        }
      },

      convertirAutotanquesEmbarque(auto) {
        const visita = Number(auto.visita)
        let masaLlenadera = 0
        const pgCargado = this.aTCargados.find( aTC => aTC.embarque === auto.embarque && aTC.visita == visita)
        
        if (pgCargado) {
          masaLlenadera = pgCargado.masaKgs
        } else {
          masaLlenadera = 0
        }
        
        return {
          ...auto,
          id: parseInt(auto.id),
          embarque: parseInt(auto.embarque),
          estado: parseInt(auto.estado),
          programa: parseInt(auto.programa),
          presion: Number(auto.presion),
          magnatel: Number(auto.magnatel),
          pesoEntrada: Number(auto.pesoEntrada),
          pesoSalida: Number(auto.pesoSalida),
          visita,
          masaLlenadera,
        }
      },
    },
    created () {
      this.iniciarComponente()
    },
  }
</script>

<style lang="scss" scoped>
  .column-blanco {
    padding-bottom: 100px;
  }
</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/tpa/cuartocontrol/Bascula.vue